(function() {
    'use strict';

    // Turmite animation for Ghost theme
    class TurmiteAnimation {
        constructor() {
            this.gridSize = 81;
            this.center = Math.floor(this.gridSize / 2);
            this.stepCount = 0;
            
            // Initialize three turmites
            this.leftTurmite = {
                x: 5,
                y: this.center,
                direction: 1, // 0=up, 1=right, 2=down, 3=left
                grid: this.createGrid()
            };
            
            this.rightTurmite = {
                x: this.gridSize - 6,
                y: this.center,
                direction: 3,
                grid: this.createGrid()
            };
            
            this.centerTurmite = {
                x: this.center,
                y: this.center,
                direction: 0,
                grid: this.createGrid()
            };
            
            // Create DOM elements
            this.leftElement = this.createTurmiteElement('left');
            this.rightElement = this.createTurmiteElement('right');
            this.centerElement = this.createTurmiteElement('center');
            
            // Start animation
            this.animate();
        }
        
        createGrid() {
            return Array(this.gridSize).fill(null).map(() => 
                Array(this.gridSize).fill(false)
            );
        }
        
        createTurmiteElement(side) {
            const element = document.createElement('div');
            element.className = 'turmite-animation turmite-' + side;
            
            let positioning = '';
            let topPosition = '50%';
            if (side === 'left') {
                positioning = 'left: 10%;';
            } else if (side === 'right') {
                positioning = 'right: 10%;';
            } else if (side === 'center') {
                positioning = 'left: 50%; transform: translateX(-50%);';
                topPosition = '10%'; // Much higher position
            }
            
            // Choose a color based on the side
            let colorVar = '--turmite-color-1';
            if (side === 'right') colorVar = '--turmite-color-2';
            else if (side === 'center') colorVar = '--turmite-color-3';
            
            element.style.cssText = `
                position: fixed;
                top: ${topPosition};
                ${positioning}
                ${side !== 'center' ? 'transform: translateY(-50%);' : ''}
                font-family: 'Courier Prime', 'Courier New', monospace;
                font-size: 0.6rem;
                line-height: 0.6rem;
                color: var(${colorVar}, #2D6A4F);
                opacity: 0.3;
                white-space: pre;
                filter: blur(0.5px);
                pointer-events: none;
                z-index: 1;
                transition: opacity 0.3s ease;
            `;
            
            document.body.appendChild(element);
            return element;
        }
        
        updateTurmite(state, bias) {
            const { x, y, direction, grid } = state;
            const newGrid = grid.map(row => [...row]);
            
            // Current cell state
            const currentCell = grid[y][x];
            
            // Langton's ant rules
            let newDirection;
            if (currentCell) {
                // On white, turn right
                newDirection = (direction + 1) % 4;
                newGrid[y][x] = false;
            } else {
                // On black, turn left with occasional spiral
                const spiralBias = this.stepCount % 50 < 2 ? 1 : 0;
                newDirection = (direction + 3 + spiralBias) % 4;
                newGrid[y][x] = true;
            }
            
            // Add bias towards center occasionally
            if (Math.random() < 0.05) {
                if (bias === 'left' && x < this.gridSize / 3) {
                    newDirection = 1; // Push right
                } else if (bias === 'right' && x > this.gridSize * 2 / 3) {
                    newDirection = 3; // Push left
                } else if (bias === 'center') {
                    // Center turmite has a slight outward spiral bias
                    if (Math.random() < 0.3) {
                        newDirection = (newDirection + 1) % 4;
                    }
                }
            }
            
            // Move forward
            let newX = x;
            let newY = y;
            switch (newDirection) {
                case 0: newY = y - 1; break; // up
                case 1: newX = x + 1; break; // right
                case 2: newY = y + 1; break; // down
                case 3: newX = x - 1; break; // left
            }
            
            // Wrap around edges
            if (newX < 0) newX = this.gridSize - 1;
            if (newX >= this.gridSize) newX = 0;
            if (newY < 0) newY = this.gridSize - 1;
            if (newY >= this.gridSize) newY = 0;
            
            return {
                x: newX,
                y: newY,
                direction: newDirection,
                grid: newGrid
            };
        }
        
        countNeighbors(grid, x, y) {
            let count = 0;
            for (let dy = -1; dy <= 1; dy++) {
                for (let dx = -1; dx <= 1; dx++) {
                    if (dx === 0 && dy === 0) continue;
                    const nx = (x + dx + this.gridSize) % this.gridSize;
                    const ny = (y + dy + this.gridSize) % this.gridSize;
                    if (grid[ny][nx]) count++;
                }
            }
            return count;
        }
        
        renderGrid(grid, turmiteX, turmiteY) {
            return grid.map((row, y) => 
                row.map((cell, x) => {
                    if (x === turmiteX && y === turmiteY) return '◉';
                    if (cell) {
                        const neighbors = this.countNeighbors(grid, x, y);
                        if (neighbors >= 6) return '※';
                        if (neighbors >= 4) return '◈';
                        if (neighbors >= 2) return '∴';
                        return '·';
                    }
                    return ' ';
                }).join('')
            ).join('\n');
        }
        
        animate() {
            // Update turmites
            this.leftTurmite = this.updateTurmite(this.leftTurmite, 'left');
            this.rightTurmite = this.updateTurmite(this.rightTurmite, 'right');
            this.centerTurmite = this.updateTurmite(this.centerTurmite, 'center');
            this.stepCount++;
            
            // Render to DOM
            this.leftElement.textContent = this.renderGrid(
                this.leftTurmite.grid, 
                this.leftTurmite.x, 
                this.leftTurmite.y
            );
            this.rightElement.textContent = this.renderGrid(
                this.rightTurmite.grid, 
                this.rightTurmite.x, 
                this.rightTurmite.y
            );
            this.centerElement.textContent = this.renderGrid(
                this.centerTurmite.grid, 
                this.centerTurmite.x, 
                this.centerTurmite.y
            );
            
            // Continue animation
            setTimeout(() => this.animate(), 50);
        }
        
        destroy() {
            if (this.leftElement) this.leftElement.remove();
            if (this.rightElement) this.rightElement.remove();
            if (this.centerElement) this.centerElement.remove();
        }
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            window.turmiteAnimation = new TurmiteAnimation();
        });
    } else {
        window.turmiteAnimation = new TurmiteAnimation();
    }
    
    // Clean up on page unload
    window.addEventListener('beforeunload', () => {
        if (window.turmiteAnimation) {
            window.turmiteAnimation.destroy();
        }
    });
})();